export default __webpack_public_path__ + "static/media/reportingIcon.49c11041.svg";